export var FOCUS_INPUT = "focus-input";
export var FOCUS_FILTER = "focus-filter";
export var FOCUS_SELECT_ALL_BUTTON = "focus-select-all";
export var FOCUS_FIRST_OPTION = "focus-first-option";
export var FOCUS_LAST_OPTION = "focus-last-option";
export var FOCUS_NEXT_OPTION = "focus-next-option";
export var FOCUS_PREVIOUS_OPTION = "focus-previous-option";
